import React, { Suspense } from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header/Header';
import Routes from './components/Routes';
import Footer from './components/Footer/Footer';
import ErrorBoundary from './components/Util/ErrorBoundary';
import Loading from './components/Util/Loading';
import './App.css';
import './style/common.css';

// TODO: Remove the token from here as per the decision.
const App = () => {
  const content = (
    <BrowserRouter>
      <Suspense
        fallback={<ProgressCircle type="circle" className="custom-loader" />}
      >
        <ErrorBoundary>
          <div style={{ minHeight: 'calc(100vh - 100px)' }}>
            <Header />
            <div className="new-line" />
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </div>
          <div className="new-line" />
          <Footer />
        </ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  );
  return content;
};

export default App;
